interface Star {
  id: number;
  left: number;
  top: number;
  size: number;
  delay: number;
}

const STAR_COUNT = 28;

function createStars(): Star[] {
  return Array.from({ length: STAR_COUNT }, (_, index) => ({
    id: index,
    left: (index * 37) % 100,
    top: (index * 53) % 100,
    size: 1 + (index % 3) * 0.75,
    delay: (index % 7) * 0.25,
  }));
}

const STARS = createStars();

export function BoardLaunchLoader(): JSX.Element {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-end overflow-hidden bg-gradient-to-b from-slate-950 via-indigo-950/60 to-slate-950"
      style={{ zIndex: 99999 }}
      role="status"
      aria-live="polite"
      aria-label="Launching your board"
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {STARS.map((star) => (
          <div
            key={star.id}
            className="absolute rounded-full bg-white animate-rocket-star-twinkle"
            style={{
              left: `${star.left}%`,
              top: `${star.top}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              animationDelay: `${star.delay}s`,
            }}
          />
        ))}
      </div>

      <div className="animate-rocket-text-fade absolute left-0 right-0 top-12 z-10 px-6 text-center md:top-16">
        <p className="text-lg font-medium text-indigo-200 md:text-xl">
          We are launching your rocket...
        </p>
        <p className="mt-2 text-2xl font-bold text-white md:text-3xl">
          Sky is the limit.
        </p>
      </div>

      <div
        className="rocket-launch-pad absolute bottom-8 left-1/2 h-1.5 w-16 -translate-x-1/2 rounded-full bg-slate-400/50"
        aria-hidden="true"
      />

      <div className="rocket-launch-container absolute bottom-8 left-1/2 flex -translate-x-1/2 flex-col items-center">
        <div className="rocket-and-flame flex flex-col items-center">
          <svg
            className="rocket-svg w-14 flex-shrink-0 md:w-16"
            viewBox="0 15 200 385"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              fill="#facc15"
              d="m56.7 106.7c5.5 0.3 9.8 3.1 15 4.3 19 4.1 39 4.3 58-0.3 5.5-1.3 8.6-3.8 14.7-4 1.4 7.2 3.4 14.1 4.9 21.2 4.3 20.5 5.3 41.1 5.4 62 0.2 49-6 97.7-18.4 145.1-1.6 5.8-2.6 9.7-4.8 15.3-20.5 0.2-42.2 0.4-62.7 0.2-5.8-17.7-9.6-35.8-12.9-54.1-4.8-25-7.9-50.2-9.4-75.6-0.5-9.8-0.2-19.5-0.4-29.2-0.8-29.6 2.6-56.4 10.6-84.9zm17.8 56.2c1 14.4 13.5 25.3 28 24.3 14.5-1 25.4-13.6 24.4-28-1-14.5-13.6-25.4-28.1-24.4-14.5 1-25.4 13.6-24.3 28.1z"
            />
            <path
              fill="#facc15"
              d="m100.1 24.3c2.5 0.8 4.1 4.9 6.7 7.3 7.2 6.8 36.5 59.1 32.4 64.9-2.7 3.8-30 7.8-38.5 7.7-11.3-0.5-23.4-1.9-34.2-5.2-4.5-1.4-7.1-2.3-5.2-7.1 7.8-20.4 17.9-40.2 30.7-58 2.4-3.3 5-6.9 8.1-9.7z"
            />
            <path
              fill="#facc15"
              d="m159.8 275.5c0.9 0.4 3.1 3.2 3.9 4.1 33.7 34 32.3 72.8 19.3 116.4-1.1-1.9-2.3-4.1-3.4-6-6.9-12.6-11.8-21.2-23.5-30.6-4.6-3.7-9-6.2-13.6-10.2 2.3-5.5 4.7-15.1 6.2-21.1q2.8-11.3 5-22.6c1.9-9.7 3.8-20.6 6.1-30z"
            />
            <path
              fill="#facc15"
              d="m41.7 276.7l0.6 0.2v1c0.5 9.9 11.2 62.4 15.6 71.4-3.4 2.8-8.5 5.9-12.1 8.8-13.1 10.4-18.5 18.1-24.9 33.1-0.7 2-0.9 3.4-1.3 5.5-10.4-22.8-15.2-58.5-5.3-82.3 5.1-12.2 16.4-30.4 27.4-37.7z"
            />
            <path
              fill="#facc15"
              d="m123.4 360l0.7 0.2c3.6 4 5.8 9.9 7.8 14.9q-27-0.3-54 0.3-4.7 0-9.3 0c1.2-2.6 6.9-14.5 9-14.8 4.1-0.6 12.9-0.3 17.3-0.3q14.2 0 28.5-0.3z"
            />
          </svg>
          <div className="rocket-flame" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
